import React from 'react'

function Logo() {
  return (
    <div className='logo'></div>
  )
}

export default Logo